import React from 'react'
import { map } from 'lodash'

import { Icon } from "@driftt/tide-core-legacy"
import StatusAvatar from 'components/shared/AgentStatusAvatar'

export const memberTitle = (user) => user.name || user.alias || ''

export default ({ members, onMemberDelete }) => (
  map(members, member => (
    {
      data: [
        {
          content: (
            <div>
              <div className="team-member-table-user">
                <StatusAvatar user={member}/>
                <div className="team-member-table-user-name">
                  <p>{memberTitle(member)}</p>
                  <p>{member.email}</p>
                </div>
                <div className="team-member-table-delete">
                  <span onClick={() => onMemberDelete(member)}>
                    <Icon
                      height={12}
                      name="close"
                      width={12}
                    />
                  </span>
                </div>
              </div>
            </div>
          )
        }
      ]
    }
  ))
)


// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/EditTeamModal/RowFormatter.js